import collectionimg from '../../assets/images/floor-covrin.png'
import collectionimgtwo from '../../assets/images/Bed-Linen.png'
import collectionimgthree from '../../assets/images/bath-linen.png'
import collectionimgfour from '../../assets/images/TableWear.jpg'
import collectionimgfive from '../../assets/images/Dustbin.jpg'
import collectionimgsix from '../../assets/images/Home-Decor.jpg' 
import { Link } from 'react-router-dom';

function HomeCategory() {
  return (
    <>

    <div id="home-category-section" className="container collection-banners">
      <div className="section-header">
        <h2> Category </h2>
          {/* <p> Shop our new arrivals from established brands </p> */}
      </div>

      <div className="row">
        <div className="col-12 col-sm-4 mb-1">
          <div className="collection-grid-item">
            <Link to="/productList">
            <img
              src={collectionimg}
              alt="Women Tops"
            />
            </Link>
            <div className="details">
              <h3 className="title"> Floor Covering </h3>
              {/* <p> From world's top designer </p> */}
              {/* <Link to="/productListsecand" className="btn">  Shop Now </Link> */}
              </div>
            </div>
        </div>

      <div className="col-12 col-sm-8 mb-4">
          <div className="row">
          <div className="col-12 col-sm-6 mb-4">
            <div className="collection-grid-item">
                <Link to="/bedlinen" > 
            <img src={collectionimgtwo} alt="Bed Linen" />
            </Link>
            <div className="details">
              <h3 className="title"> Bed Linen </h3>
              {/* <p> Find your perfect outfit </p> */}
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 mb-4">
          <div className="collection-grid-item">
            <Link to="/bathline" > 
            <img src={collectionimgthree} alt="bath Linen" />
            </Link>
            <div className="details">
              <h3 className="title"> Bath Linen </h3>
              {/* <p> Find your perfect outfit </p> */}
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 mb-1">
          <div className="collection-grid-item">
            <Link to="/tablewear" > 
            <img src={collectionimgfour} alt="bath Linen" />
            </Link>
            <div className="details">
              <h3 className="title"> TableWear </h3>
              {/* <p> Find your perfect outfit </p> */}
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 mb-1">
          <div className="collection-grid-item">
            <Link to="/dustbin" > 
            <img src={collectionimgfive} alt="Home Accessories" />
            </Link>
            <div className="details">
              <h3 className="title"> Home Accessories </h3>
              {/* <p> Find your perfect outfit </p> */}
          </div>
            </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-12 mb-5">
          <div className="collection-grid-item">
            <Link to="/homedecor">
            <img
              src={collectionimgsix}
              alt="Women Tops"
            />
            </Link>
            <div className="details">
              <h3 className="title"> Home Decor  </h3>
              {/* <p> From world's top designer </p> */}
              {/* <Link to="/productListsecand" className="btn">  Shop Now </Link> */}
              </div>
            </div>
          </div>
      </div>
    </div>
    
    </>
  );
}
export default HomeCategory;